var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 21,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1379 14.9289V10H29.6322V14.9289M18.1379 14.9289H29.6322M18.1379 14.9289H14V27.336H17.2184M29.6322 14.9289H34V27.336H30.5517M17.2184 27.336C17.2184 28.809 17.2184 31.789 17.2184 31.9249C17.2184 32.0609 26.1073 31.9816 30.5517 31.9249V27.336M17.2184 27.336V23.087M16.4521 23.087H17.2184M17.2184 23.087H31.3946H30.5517V26.3162V27.336M19.6705 24.9565H28.0996C28.355 25.0698 28.7126 25.3644 28.0996 25.6364H19.6705C19.5172 25.5514 19.3027 25.2965 19.6705 24.9565ZM19.6705 26.8261H28.0996C28.304 27.0244 28.59 27.472 28.0996 27.6759H19.6705C19.4917 27.5626 19.2414 27.234 19.6705 26.8261ZM19.6705 28.8656H28.0996C28.3806 29.0639 28.7739 29.4945 28.0996 29.6305H19.6705C19.4662 29.5171 19.1801 29.2056 19.6705 28.8656Z",
    stroke: "#2f67ca",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormPrint);
export default __webpack_public_path__ + "static/media/FormPrint.b8140acc89975df8010409496b981ac1.svg";
export { ForwardRef as ReactComponent };